import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Check, PhoneCall, FileSearch, CalendarCheck } from 'lucide-react'
import UploadBox from '../components/UploadBox.jsx'

const passos = ['Seus dados', 'Documentos', 'Consentimento', 'Pronto']

export default function Documentos() {
  const [passo, setPasso] = useState(0)

  return (
    <main className="mx-auto max-w-2xl px-4 py-6 md:py-10">
      <h1 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">Envio de documentos</h1>
      <p className="mt-1 text-slate-500">Tudo online, uma vez só. A gente cuida do resto.</p>

      {/* Stepper */}
      <div className="mt-6 flex items-center gap-2 md:mt-8">
        {passos.map((p, i) => (
          <div key={p} className="flex flex-1 items-center gap-2">
            <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold ${i < passo ? 'bg-brand-600 text-white' : i === passo ? 'border-2 border-brand-600 bg-white text-brand-700' : 'border-2 border-slate-200 bg-white text-slate-400'}`}>
              {i < passo ? <Check size={16} /> : i + 1}
            </div>
            <span className={`hidden text-xs font-medium sm:block ${i === passo ? 'text-brand-700' : 'text-slate-400'}`}>{p}</span>
            {i < passos.length - 1 && <div className={`h-0.5 flex-1 rounded ${i < passo ? 'bg-brand-600' : 'bg-slate-200'}`} />}
          </div>
        ))}
      </div>
      <div className="mt-2 text-center text-xs font-semibold text-brand-700 sm:hidden">{passos[passo]}</div>

      <div className="mt-5 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm md:mt-8 md:p-6">
        {passo === 0 && (
          <form className="space-y-3" onSubmit={(e) => { e.preventDefault(); setPasso(1) }}>
            <div className="grid gap-3 sm:grid-cols-2">
              <input required placeholder="Nome completo" className="rounded-xl border border-slate-300 px-4 py-2.5 text-base outline-none sm:text-sm focus:border-brand-600 sm:col-span-2" />
              <input required placeholder="CPF" className="rounded-xl border border-slate-300 px-4 py-2.5 text-base outline-none sm:text-sm focus:border-brand-600" />
              <input required placeholder="Data de nascimento" className="rounded-xl border border-slate-300 px-4 py-2.5 text-base outline-none sm:text-sm focus:border-brand-600" />
              <input required placeholder="WhatsApp (DDD + número)" className="rounded-xl border border-slate-300 px-4 py-2.5 text-base outline-none sm:text-sm focus:border-brand-600" />
              <input type="email" placeholder="E-mail" className="rounded-xl border border-slate-300 px-4 py-2.5 text-base outline-none sm:text-sm focus:border-brand-600" />
              <input required placeholder="Profissão / fonte de renda" className="rounded-xl border border-slate-300 px-4 py-2.5 text-base outline-none sm:text-sm focus:border-brand-600 sm:col-span-2" />
            </div>
            <button className="w-full rounded-xl bg-brand-600 py-3 font-semibold text-white transition hover:bg-brand-700">Continuar</button>
          </form>
        )}

        {passo === 1 && (
          <div className="space-y-3">
            <UploadBox label="CNH (obrigatória — você vai dirigir!)" />
            <UploadBox label="Comprovante de residência" />
            <UploadBox label="Comprovante de renda (holerite, extrato ou IR)" />
            <div className="flex gap-2 pt-2">
              <button onClick={() => setPasso(0)} className="rounded-xl border border-slate-300 px-5 py-3 text-sm font-medium text-slate-600 hover:border-slate-400">Voltar</button>
              <button onClick={() => setPasso(2)} className="flex-1 rounded-xl bg-brand-600 py-3 font-semibold text-white transition hover:bg-brand-700">Continuar</button>
            </div>
          </div>
        )}

        {passo === 2 && (
          <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); setPasso(3) }}>
            <label className="flex items-start gap-3 rounded-xl border border-slate-200 p-4 text-sm text-slate-600">
              <input type="checkbox" required className="mt-0.5 h-4 w-4 accent-brand-600" />
              Autorizo a Sim a consultar meu CPF em birôs de crédito (Serasa/SPC) exclusivamente para esta análise.
            </label>
            <label className="flex items-start gap-3 rounded-xl border border-slate-200 p-4 text-sm text-slate-600">
              <input type="checkbox" required className="mt-0.5 h-4 w-4 accent-brand-600" />
              Concordo com o tratamento dos meus dados conforme a LGPD, apenas para a análise e contato da Sim.
            </label>
            <div className="flex gap-2">
              <button type="button" onClick={() => setPasso(1)} className="rounded-xl border border-slate-300 px-5 py-3 text-sm font-medium text-slate-600 hover:border-slate-400">Voltar</button>
              <button className="flex-1 rounded-xl bg-brand-600 py-3 font-semibold text-white transition hover:bg-brand-700">Enviar para análise</button>
            </div>
          </form>
        )}

        {passo === 3 && (
          <div className="text-center">
            <div className="mx-auto inline-flex rounded-full bg-brand-50 p-4 text-brand-600"><Check size={36} /></div>
            <h2 className="font-display mt-4 text-2xl font-extrabold">Agora é com a gente! 💚</h2>
            <p className="mx-auto mt-2 max-w-sm text-sm text-slate-500">Seus documentos chegaram. Os próximos passos:</p>
            <div className="mx-auto mt-6 max-w-sm space-y-3 text-left">
              {[
                { icon: FileSearch, t: 'Análise dos documentos', d: 'Nossa equipe revisa tudo com carinho.' },
                { icon: PhoneCall, t: 'Ligação no seu WhatsApp', d: 'Combinamos os detalhes com você.' },
                { icon: CalendarCheck, t: 'Visita e test drive', d: 'Você conhece o carro de perto antes de fechar.' },
              ].map(({ icon: Icon, t, d }) => (
                <div key={t} className="flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-4">
                  <span className="rounded-lg bg-brand-50 p-2 text-brand-700"><Icon size={18} /></span>
                  <div>
                    <div className="text-sm font-semibold text-slate-800">{t}</div>
                    <div className="text-xs text-slate-500">{d}</div>
                  </div>
                </div>
              ))}
            </div>
            <Link to="/carros" className="mt-6 inline-block rounded-full border border-slate-300 px-6 py-3 text-sm font-semibold text-slate-600 hover:border-slate-400">
              Voltar ao catálogo
            </Link>
          </div>
        )}
      </div>
    </main>
  )
}
